export const CREDITS_ASSIGNMENT_WIZARD_NAMESPACE = 'credits-assignment';

export const CREDITS_STEPS = {
  EMPLOYEES_SELECTION: 'employees-selection',
  CREDIT_TYPE_SELECTION: 'credit-type-selection',
  AMOUNT_ASSIGNMENT: 'amount-assignment',
  ASSIGNMENT_RECAP: 'assignment-recap',
} as const;
